import { useIsUploadingFile } from '@/hooks/files/use-upload-file';
import useSession from '@/hooks/sessions/use-session';
import useFriendInfo from '@/hooks/users/use-friend-info';
import type { ConversationSessionType } from '@/models/conversations/conversation-session';
import { useFriendBySessionId } from '../contacts/use-friends';

export function useSessionMessages(sessionId?: number) {
  const { session } = useSession<ConversationSessionType>('session', sessionId);
  const { friend } = useFriendBySessionId(sessionId);

  const {
    friendInfo,
    isLoading: isFriendLoading,
    error: friendInfoError,
  } = useFriendInfo(session?.UserID || friend?.FriendID);

  const isUploadingFile = useIsUploadingFile();

  return {
    friendInfo,
    session,
    isLoading: isUploadingFile || isFriendLoading,
    error: friendInfoError,
  } as const;
}
